/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/anchor-has-content */
import "./index.css";
import { Row, Col, Input } from "antd";
import Image from "../Image";
import WordedLogo from "../../images/worded_logo.svg";
import {
  FacebookFilled,
  InstagramOutlined,
  MailOutlined,
  TwitterOutlined,
  YoutubeOutlined
} from "@ant-design/icons";
const { Search } = Input;
export const Footer = (props) => {
  return (
    <Row className="footer-container">
      <Col
        xs={24}
        sm={24}
        lg={6}
        xl={6}
        className="footer-div-flex"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        }}
      >
        <ul>
          <li className="list-style">
            <Image src={WordedLogo} w="130px" />
            <p className="slogan">
              {/* MIT License your project Lorem ipsum dolor sit amet, consetetur
                sadipscin */}
              Digital Asset & Agent <br className="d-none d-xl-block d-lg-block d-md-block"/> Management Inc.
            </p>
            <span style={{ padding: "5px" }}>
              <InstagramOutlined
                style={{ fontSize: "25px", color: "#FF4040" }}
              />
            </span>
            <span style={{ padding: "5px" }}>
              <FacebookFilled style={{ fontSize: "25px", color: "#FF4040" }} />
            </span>
            <span style={{ padding: "5px" }}>
              <TwitterOutlined style={{ fontSize: "25px", color: "#FF4040" }} />
            </span>
            <span style={{ padding: "5px" }}>
              <YoutubeOutlined style={{ fontSize: "25px", color: "#FF4040" }} />
            </span>
          </li>
        </ul>
      </Col>
      <Col lg={12} xl={12} sm={24} xs={24}>
        <Row>
          <Col xs={8} sm={8} lg={8} xl={8} className="footer-div">
            <ul className="footer-link">
              <li className="list-header">
                <a>MARKETPLACE</a>
              </li>
              <li className="list-style">
                <a>Featured</a>
              </li>
              <li className="list-style">
                <a>Flowscan Activity</a>
              </li>
              <li className="list-style">
                <a>Storms</a>
              </li>
              <li className="list-style">
                <a>Login/Register</a>
              </li>
            </ul>
          </Col>
          <Col xs={8} sm={8} lg={8} xl={8} className="footer-div">
            <ul className="footer-link">
              <li className="list-header">
                <a>COMPANY</a>
              </li>
              <li className="list-style">
                <a>Team</a>
              </li>
              <li className="list-style">
                <a>Agents</a>
              </li>
              <li className="list-style">
                <a>Eco-Pledge</a>
              </li>
              <li className="list-style">
                <a>Blog</a>
              </li>
            </ul>
          </Col>
          <Col xs={8} sm={8} lg={8} xl={8} className="footer-div">
            <ul className="footer-link">
              <li className="list-header">
                <a>RESOURCES</a>
              </li>
              <li className="list-style">
                <a>Flowscan</a>
              </li>
              <li className="list-style">
                <a>Filecoin</a>
              </li>
              <li className="list-style">
                <a>Blocto</a>
              </li>
              <li className="list-style">
                <a>Blog</a>
              </li>
            </ul>
          </Col>
        </Row>
      </Col>

      <Col xs={24} sm={24} lg={6} xl={6} className="footer-div">
        <ul className="footer-link">
          <li className="list-header">
            <a>SUBSCRIBE</a>
          </li>
          <li className="list-style">
            <a>Get community events, news and free tutorials.</a>
          </li>
          {/* <div style={{ height: "40px" }}>
              <input className="subscribinput" placeholder=" &#xf0e0; Email" />
              <button className="subscribe-btn">subscribe</button>
            </div> */}

          {/* <InputEmail
              placeholder="Email"
              allowClear
              enterButton="SIGN UP"
              size="large"
              prefix={<MailOutlined style={{ fontSize: "20px" }} />}
            /> */}
          <Search
            className="place"
            placeholder="Email"
            allowClear
            enterButton="Sign up"
            size="large"
            prefix={
              <MailOutlined
                style={{
                  color: "#757575",
                  fontSize: "20px"
                }}
              />
            }
            style={{
              width: "20vw"
            }}
            // onSearch={onSearch}
          />
          {/* <div className="social-icon"></div> */}
        </ul>
      </Col>
    </Row>
  );
};

export default Footer;
